import type { Rate, RateImage } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'
import { resolveFilePath } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/getMediaUrl'

/**
 * Фотографии отзыва для превью в карточке.
 *
 * В галерею попадают только кадры с `img_s`:
 * без миниатюры превью не из чего собрать, полный файл в сетку не кладётся.
 */
export default function getRateImages(rate: Rate): RateImage[] {
  const images = rate.get_images || rate.images || []

  return images.filter(image => Boolean(resolveFilePath(image.img_s)))
}
